<div class="content">
  <form class="family-history-form" [formGroup]="familyHistoryForm" (submit)="addFamilyHistoryItem()">
    <div>
      <mat-form-field class="options">
        <input
          #input_condition
          type="text"
          placeholder="{{ 'choose_a_condition' | translate }}"
          matInput
          [matAutocomplete]="auto"
          formControlName="description"
          (input)="filterCondition()"
          (focus)="filterCondition()"
          [value]="familyHistoryForm.get('description').value | translate"
        />
        <mat-autocomplete #auto="matAutocomplete" requireSelection gcFormField gcFormFieldNoError placeholder="Choose a condition">
          <mat-option *ngFor="let option of familyHistoryOptions" [value]="option">
            {{ option | translate }}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
      <mat-form-field *ngIf="selectedOption" class="note">
        <mat-label>{{ 'add_a_note_about_condition' | translate: { condition: (selectedOption | translate) } }}</mat-label>
        <input matInput type="text" name="note" formControlName="note" gcFormField gcFormFieldNoError />
      </mat-form-field>
    </div>
    <div class="add-content">
      <button mat-flat-button type="submit" class="add-button" [disabled]="familyHistoryForm.invalid">
        <mat-icon svgIcon="plus"></mat-icon>
        {{ 'add_family_history_option' | translate }}
      </button>
    </div>
    <div class="divider"></div>
  </form>
  <div class="history-display" [formGroup]="familyConditionListForm">
    <mat-accordion multi="true">
      <mat-expansion-panel
        class="history-line"
        formArrayName="familyConditionList"
        *ngFor="let historyItem of familyConditionList.controls; let i = index"
        #panel
      >
        <mat-expansion-panel-header>
          <span class="panel-title">
            <div class="title-text" [class.expanded]="panel.expanded">{{ historyItem.value.description | translate }}</div>
          </span>
        </mat-expansion-panel-header>
        <div [formGroupName]="i">
          <mat-form-field class="note">
            <textarea matInput type="text" formControlName="note" gcFormField gcFormFieldNoError></textarea>
          </mat-form-field>
        </div>
        <div class="delete-button">
          <button mat-raised-button color="warn" class="delete-button" (click)="deleteFamilyHistoryItem(i)">
            <mat-icon svgIcon="delete"></mat-icon>
            {{ 'delete' | translate }}
          </button>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
  <div class="save">
    <button
      mat-flat-button
      [ngClass]="{ primary: requestUuid === null, accent: requestUuid !== null }"
      class="save-button"
      (click)="submit()"
    >
      <mat-icon svgIcon="check"></mat-icon>
      {{ 'save_family_history' | translate }}
    </button>
  </div>
</div>
